var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToolbarLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16,16.77a1.57,1.57,0,0,0,1.54-1.55V7.54a1.54,1.54,0,1,0-3.08,0v7.68A1.57,1.57,0,0,0,16,16.77Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3,12.67a9.07,9.07,0,0,0-2.72-3.24,1.53,1.53,0,0,0-1.15-.3,1.45,1.45,0,0,0-1,.6,1.48,1.48,0,0,0-.29,1.13,1.45,1.45,0,0,0,.56,1A6.22,6.22,0,0,1,21.51,14a6.15,6.15,0,0,1,.16,5.12,6.26,6.26,0,0,1-1.32,2,6.12,6.12,0,0,1-2,1.31,6.05,6.05,0,0,1-4.76,0,6.12,6.12,0,0,1-2-1.31,6.26,6.26,0,0,1-1.32-2A6.15,6.15,0,0,1,10.49,14a6.22,6.22,0,0,1,1.82-2.19,1.4,1.4,0,0,0,.59-1,1.47,1.47,0,0,0-.29-1.14,1.43,1.43,0,0,0-1-.59,1.47,1.47,0,0,0-1.16.3,9.09,9.09,0,0,0-3.68,7.37,8.82,8.82,0,0,0,.73,3.58,9.23,9.23,0,0,0,12.09,4.91,9.12,9.12,0,0,0,4.91-4.91,8.82,8.82,0,0,0,.73-3.58A9.12,9.12,0,0,0,24.3,12.67Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolbarLogout);
export default __webpack_public_path__ + "static/media/toolbar-logout.04a4dced.svg";
export { ForwardRef as ReactComponent };